import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsBurndownRoute: InvariantJiraRoute = {
	name: 'software-reports-burndown',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown',
};
